export type UserRole =
  | 'Admin'
  | 'SuperAdmin'
  | 'Compliance'
  | 'Finance'
  | 'Support'
  | 'User'
  | 'Guest';

export const ACCOUNT_USER_ROLES: UserRole[] = ['User', 'Admin', 'SuperAdmin', 'Compliance', 'Finance', 'Support'];
export const ADMIN_ROLES: UserRole[] = ['Admin', 'SuperAdmin'];
export const STAFF_ROLES: UserRole[] = ['Admin', 'SuperAdmin', 'Compliance', 'Finance', 'Support'];
export const COMPLIANCE_ROLES: UserRole[] = ['Admin', 'SuperAdmin', 'Compliance'];
export const FINANCE_ROLES: UserRole[] = ['Admin', 'SuperAdmin', 'Finance'];
export const HOUSE_MANAGEMENT_ROLES: UserRole[] = ['SuperAdmin', 'Finance'];
export const HOUSE_MARKET_MAKER_ROLES: UserRole[] = ['SuperAdmin'];
export const HOUSE_WITHDRAWAL_ROLES: UserRole[] = ['SuperAdmin'];
export const SUPPORT_ROLES: UserRole[] = ['Admin', 'SuperAdmin', 'Support'];
export const COMPLIANCE_OR_FINANCE_ROLES: UserRole[] = ['Admin', 'SuperAdmin', 'Compliance', 'Finance'];

export function hasAnyRole(role: string | null | undefined, allowedRoles: readonly UserRole[]): boolean {
  return !!role && allowedRoles.includes(role as UserRole);
}

export const COMPLIANCE_ML_PREDICTION_TYPES = [
  'LoginRisk',
  'LoginRiskDecision',
  'LoginRiskMlNetShadow',
  'WithdrawalRisk',
  'WithdrawalRiskDecision',
  'DepositRisk'
] as const;

export const FINANCE_ML_PREDICTION_TYPES = [
  'WithdrawalRisk',
  'WithdrawalRiskDecision',
  'MatchCandidateRisk',
  'MatchCandidateSelection',
  'SettlementReliability',
  'GatewayWebhookReliability',
  'LiquidityImbalanceForecast'
] as const;

export const ALL_ML_PREDICTION_TYPES = Array.from(new Set([
  ...COMPLIANCE_ML_PREDICTION_TYPES,
  ...FINANCE_ML_PREDICTION_TYPES
]));

export function mlPredictionTypesForRole(role: string | null | undefined): string[] {
  if (role === 'Compliance') return [...COMPLIANCE_ML_PREDICTION_TYPES];
  if (role === 'Finance') return [...FINANCE_ML_PREDICTION_TYPES];
  if (role === 'Admin' || role === 'SuperAdmin') return [...ALL_ML_PREDICTION_TYPES];
  return [];
}
